var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"treatment-directory-modal","classes":['modal-window'],"transition":"scale","adaptive":"","click-to-close":false,"width":"800px","height":"700px"}},[_c('div',{staticClass:"modal-container"},[_c('treatment-directory')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }